/** @prettier */
import React from "react";
import { TestSummaryItem } from "../View/TestSummaryBar";
import { QuestionResult, TestReviewDispatch } from "./testReviewState";

export type ReviewQuestionSummaryState = {
    isFiltered: boolean;
    result: QuestionResult;
    isFlagged: boolean;
};
export type TestReviewSummaryBarProps = {
    dispatch: TestReviewDispatch;
    questionNumber: number;
    summaryQuestions: ReviewQuestionSummaryState[];
};
const TestReviewSummaryBar = ({
    dispatch,
    questionNumber,
    summaryQuestions,
}: TestReviewSummaryBarProps) => (
    <div className="tr-summary">
        <div className="tr-summary-item">Review</div>
        {summaryQuestions.map(({ isFiltered, result, isFlagged }, i) => (
            <TestSummaryItem
                key={i}
                index={i}
                current={i === questionNumber}
                dispatch={dispatch}
                isFiltered={isFiltered}
                isFlagged={isFlagged}
                result={result}
            />
        ))}
    </div>
);
export default TestReviewSummaryBar;
